module.exports = __webpack_public_path__ + "media/images/favicon-59241daee5ec97ce0651e38aff9648d2.ico";